
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['pageStr'],
  setup() {
    const customerDesigns: Array<object> = [
      {
        image: 'customer_design_1',
        link: 'weddingRings',
      },
      {
        image: 'customer_design_2',
        link: 'memoireRingsColored',
      },
      {
        image: 'customer_design_3',
        link: 'engagementRings',
      },
      {
        image: 'customer_design_4',
        link: 'weddingRingsSecretHeart',
      },
      {
        image: 'customer_design_5',
        link: 'weddingRingsStarrySky',
      },
      {
        image: 'customer_design_6',
        link: 'weddingRingsPlain',
      },
      {
        image: 'customer_design_7',
        link: 'weddingRingsClassic',
      },
      {
        image: 'customer_design_8',
        link: 'weddingRingsFancy',
      },
      {
        image: 'customer_design_9',
        link: 'weddingRingsClassic',
      },
      {
        image: 'customer_design_10',
        link: 'weddingRings',
      },
    ]

    return { customerDesigns }
  },
})
